import React from 'react';

// import NavbarPrivate from '@/features/v2/shared/Header/navbars/navbarPrivate/NavbarPrivate';

import LoopVideo from './components/LoopVideo';
import { HeaderProps } from './interfaces';

const Header = ({
  children, isVideo, loopVideoProps = {
    images: [],
  },
}: HeaderProps) => {
  return (
    <header className="relative w-full" aria-label="Banner principal">
      <div className="relative flex flex-col md:flex-row-reverse items-center justify-center z-10 text-center">
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        {isVideo && <LoopVideo {...loopVideoProps} />}
        <div className="fade-bottom" />
        {children}
      </div>
    </header>
  );
};

export default Header;
